import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface RoutineCommentChangeState {
    requests: {
        state: LoadStateInfo;
        request: RoutineCommentChangeRequest
    }[];
}

const initialState: RoutineCommentChangeState = {
    requests: [],
};
export function findRoutineCommentRequest(requests: RoutineCommentChangeState["requests"], payload: RoutineCommentChangeRequest) {
    console.log(`findRoutineCommentRequest for classroom ${payload.classroomId}, date ${payload.eventDate}, student ${payload.studentId}, routine item ${payload.routineId}`);
    return requests.find((r) =>
        r.request.classroomId == payload.classroomId &&
        r.request.studentId == payload.studentId &&
        r.request.eventDate == payload.eventDate &&
        r.request.routineId == payload.routineId
    );
}
export interface RoutineCommentChangeRequest {
    schoolId: string;
    classroomId: string;
    studentId: string;
    eventDate: string;
    routineId: string;
    comment?: string;
}
export const routineCommentChange = createAsyncThunk(
    "routineCommentChange",
    async (param: RoutineCommentChangeRequest, thunkAPI) => {
        console.debug(`change routine comment for classroom ${param.classroomId}, date ${param.eventDate}, student ${param.studentId}, routine item ${param.routineId} to comment ${param.comment}`);

        const response = await fetch(`${getBackendUrl()}/api/routine-comment/change`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    // {
    //     condition: (param: RoutineRecordChangeRequest, thunkAPI) => {
    //         const state = thunkAPI.getState() as RootState;
    //         const status = state.routineRecordList;
    //         if (!status || !status.state) {
    //             return true;
    //         }
    //         if (status.state.state == LoadState.NotStarted) {
    //             return true;
    //         }
    //         console.debug(`retrieveRoutineRecordList skipped: ${status.state.state}`);
    //         return false;
    //     }
    // }
);

export const routineCommentChangeSlice = createSlice({
    name: "routineCommentChangeList",
    initialState,
    reducers: {
        clear: (state, action: PayloadAction<RoutineCommentChangeRequest>) => {
            const request = findRoutineCommentRequest(state.requests, action.payload);
            if (request) {
                request.state = notStarted();
                request.request = action.payload;
            } else if (!request) {
                state.requests.push({
                    state: notStarted(),
                    request: action.payload
                });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(routineCommentChange.pending, (state, action) => {
                const payload = action.meta.arg;
                const request = findRoutineCommentRequest(state.requests, payload);
                if (request) {
                    request.state = loading();
                    request.request = payload;
                } else if (!request) {
                    state.requests.push({
                        state: loading(),
                        request: payload
                    });
                }
            })
            .addCase(routineCommentChange.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                const payload = action.meta.arg;
                const request = findRoutineCommentRequest(state.requests, payload);
                if (request) {
                    request.state = loaded();
                    request.request = payload;
                }
            })
            .addCase(routineCommentChange.rejected, (state, action) => {
                const payload = action.meta.arg;
                const request = findRoutineCommentRequest(state.requests, payload);
                if (request) {
                    request.state = error(action);
                    request.request = payload;
                }
            });
    },
});

// export const { } = routineCommentChangeSlice.actions;

export const selectRoutineCommentChange = (state: RootState) => state.routineCommentChange;

export default routineCommentChangeSlice.reducer;
